Drupal.behaviors.cardCollection = {
  attach: function attach() {
    var boxes = document.querySelectorAll('.m-card');
    boxes.forEach(function (box) {
      var link = box.querySelector('.m-card__content h3 a');
      box.classList.add('m-card--hover');
      if (link) {
        var url = link.getAttribute('href');
        box.addEventListener('click', function () {
          window.location.href = url;
          link.preventDefault();
        });
        link.addEventListener('focus', function () {
          box.classList.add('m-card--focused');
        });
        link.addEventListener('blur', function () {
          box.classList.remove('m-card--focused');
        });
      }
    });
  }
};